export default __webpack_public_path__ + "static/media/timer-icon.12b0a6da.svg";